export default __webpack_public_path__ + "static/industryImg-5a8a03659c1d094941fba604edaa048c.png";